/**
 * @description
 * Image is usually only visual representation and therefore is hidden from screen readers, unless 'alt' property is provided.
 *
 * @specification
 * Adds attribute 'aria-hidden=true', if there is no 'alt' property provided.
 */
export var imageBehavior = function imageBehavior(props) {
  return {
    attributes: {
      root: {
        'aria-hidden': props.alt || props['aria-label'] ? undefined : 'true'
      }
    }
  };
};
//# sourceMappingURL=imageBehavior.js.map
